export default {
  uploadedCsvList: (state) => state.uploadedCsvList,
  batchList: (state) => state.batchList
};
